import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner'

import { ValidatorUtils } from '../../utils';
import { Routes as routes, History as history } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, InstantActions, ToastActions } from '../../actions';
import { SingleScreenNavBar, TitleBar, NavBar, Header, Input, PhoneInput, AuthCheck, Line } from  '../../components'

class InstantHelpScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected_index: null,
    }
  }

  componentDidMount() {

  }

  renderVideo = (video_name) => {

    if (!video_name) {
      return null;
    }

    let is_setup_video = video_name === 'setup_video';
    let is_start_sesh  = video_name === 'start_session_video';

    return <div className='flex-container-column' style={{ padding: 15, paddingTop: 20, paddingBottom: 20, alignItems: 'center', backgroundColor: 'black' }}>
      { is_setup_video ? <iframe width="640" height="315" src="https://www.youtube.com/embed/8OywioSiDsU" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe> : null }
      { is_start_sesh  ? <iframe width="640" height="315" src="https://www.youtube.com/embed/rBqcMWpITlE" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe> : null }
    </div>
  }

  renderFAQRow = (faq, index) => {
    let question       = faq.subject;
    let answer         = faq.body;
    let display_answer = this.state.selected_index === index ? true : false;
    let class_names    = display_answer ? 'instant-faq-row' : 'instant-faq-row-selectable';
    let display_vid    = answer === 'start_session_video' || answer === 'setup_video' ? true : false;
    let vid_name       = display_vid && display_answer ? answer : '';
        answer         = display_vid ? '' : answer;

    return <div className={'flex-container-column'} key={index}>
      <div className={'flex-container-column ' + class_names }
           onClick={ () => {
             if (!display_answer) {
               this.setState({ ...this.state, selected_index: index });
             }
           }}>
        <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ fontSize: display_answer ? 20 : 14, marginBottom: display_answer ? 10 : 0, fontWeight: display_answer ? 'bold' : '' }}
             onClick={ () => {
               this.setState({ ...this.state, selected_index: null });
             }}>
          { question }
        </div>
          { display_answer ? <span className='instant-cancel-button flex-container-column'
                                   style={{ justifyContent: 'center', alignItems: 'center' }}
                                   onClick={ () => {
                                     this.setState({ ...this.state, selected_index: null });
                                   }}>
            <span className='fas fa-minus' style={{ fontSize: 16, color: '#1dc2ff' }} />
          </span> : null }
        </div>
        { display_answer ? <div style={{ fontSize: 14, color: 'grey' }}>{ answer }</div> : null  }
        { display_vid    ? this.renderVideo(vid_name) : null }
      </div>
      <Line style={{ backgroundColor: '#f5f5f5' }} />
    </div>
  }

  renderFAQRows = () => {
    let faq_objects = this.getFaqObjects();

    let faq_rows = faq_objects.map((faq, index) => {
      return this.renderFAQRow(faq, index)
    })

    return <div>
      { faq_rows }
    </div>
  }

  renderContentContainers = () => {

    let props    = this.props.location && this.props.location.state ? this.props.location.state.props : {};
    let hide_nav = props && props!== null && props.is_no_nav ? true : false;

    if (hide_nav) {
      return <div className="flex-container screen-main-content" style={{  }}>
          <div className="flex-container-column" style={{ marginTop: 30 }}>
          <div className='flex-container-row'>
          <span className='fas fa-arrow-circle-left instant-back-button'
                style={{ fontSize: 30, marginTop: 5 }}
                onClick={ () => {
                  history.goBack();
                }} />
            <div className='instant-settings-container' style={{ width: 700, marginTop: 0, marginLeft: 20, marginRight: 20 }}>
              <Header title='FAQs' icon='fas fa-info-circle' />
              { this.renderFAQRows() }
            </div>
            </div>
          </div>
      </div>
    }

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column flex-container-column" style={{ alignItems: 'center' }}>
        <div className='instant-settings-container' style={{ width: 700 }}>
          <Header title='FAQs' icon='fas fa-info-circle' />
          { this.renderFAQRows() }
        </div>
      </div>
    </div>
  }

  render() {
    let props    = this.props.location && this.props.location.state ? this.props.location.state.props : {};
    let hide_nav = props && props !== null && props.is_no_nav ? true : false;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        { props.is_no_nav ? null : <AuthCheck user={this.props.user} userActions={this.props.userActions} /> }
        { props.is_no_nav ? null : <TitleBar
          practice={this.props.practice.practice}
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
        /> }
        <SingleScreenNavBar title="Instant FAQs" />
        { this.renderContentContainers() }
      </div>
    );
  }

  getFaqObjects = () => {
    let faqs = [];

    let faq_1 = {
      subject: 'How do I start an Instant Session?',
      body: 'start_session_video'
    }

    let faq_2 = {
      subject: 'Can you walk me through the entire set-up process?',
      body: 'setup_video'
    }

    let faq_3 = {
      subject: 'What will I need to create an account as a care provider?',
      body: 'You’ll need a valid email address to create an account. Your computer or mobile device should have audio and video capabilities.'
    }

    let faq_4 = {
      subject: 'I can’t find my validation code',
      body: 'Please search your inbox for “TeleTails Verify”. The email should come from rosie@teletails.com and may be in your spam profile. Please hold off resetting your password until you search in spam.'
    }

    let faq_5 = {
      subject: 'What do my clients need?',
      body: 'Access to receive text messages and an internet browser.'
    }

    let faq_6 = {
      subject: 'Are there browser requirements?',
      body: 'On web, Google Chrome is best. Safari also works well. Just try not to use a really outdated browser or the videos probably won’t render as quickly!'
    }

    let faq_7 = {
      subject: 'Are there phone requirements?',
      body: 'Anything produced in the last few years should work. We support both Apple and Android phones/tablets.'
    }

    let faq_8 = {
      subject: 'Why is there also a code listed?',
      body: 'Codes are another way to connect to a session. Often times, CSR teams start a consultation and then providers will join via a tablet. This way, the team can join from different devices on-the-go without having to be on the main TeleTails Instant page.'
    }

    let faq_9 = {
      subject: 'How will my clients be notified that I’ve started an Instant Session?',
      body: 'Clients will receive a text message with an invite code and a direct URL link into a session. You should suggest they click the link. If they have any technical issues, have them download TeleTails and then insert the code from the home page prior to creating an account.'
    }

    let faq_10 = {
      subject: 'What if I can’t see my clients?',
      body: 'When a client joins a session, they must enable video and audio. Inevitably, a client will automatically choose to disable audio/video while joining a session. If this occurs, instruct the client to follow one of the below steps. Generally, there should be a lock or related icon in their url bar that will allow them to change their settings:\nChange Google Chrome Permissions\nFirefox Support'
    }

    let faq_11 = {
      subject: 'How do I get started?',
      body: 'We recommend starting a sample Instant session with a colleague before connecting with clients to test your connection, audio, and lighting. Add a message on your website that you are now offering curbside video sessions, for example, as a starting point. Make sure your CSR team is well versed in how the system operates and can indicate to your support team when they should start a session.'
    }

    let faq_12 = {
      subject: 'How are people using this?',
      body: 'Primary use cases include curbside drop-offs, follow-ups, and situations in which a client has difficulty creating an in-app profile.'
    }

    faqs.push(faq_1);
    faqs.push(faq_2);
    faqs.push(faq_3);
    faqs.push(faq_4);
    faqs.push(faq_5);
    faqs.push(faq_6);
    faqs.push(faq_7);
    faqs.push(faq_8);
    faqs.push(faq_9);
    faqs.push(faq_10);
    faqs.push(faq_11);
    faqs.push(faq_12);


    return faqs;
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    instant: state.instant,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    instantActions: bindActionCreators(
     { ...InstantActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstantHelpScreen)
